export function update(id, tags) {
    let result = {};

    Object.keys(tags).forEach((tag) => {
        result[tag] = {
            values: tags[tag]
        };
    });

    return bulk(id, result);
}

export function bulk(id, tags) {
    if (!tags) { // @FIXME: when tags model will be fully ready it can be deleted
        tags = id;
        id = null;
    }

    return {
        type: 'TAGS_UPDATE',
        tags,
        id
    };
}
